import { Component } from '@angular/core';
import { MaintenanceComponent } from '../../shared/components/maintenance.page';
@Component({
  selector: 'wat-maintenance-page',
  standalone: true,
  imports: [MaintenanceComponent],
  template: `
    <ui-ng-maintenance ngClass="mb-3"></ui-ng-maintenance>
  `,
  styles: ``
})
export class MaintenancePageComponent {

}
